<template>
  <div>
    <section-definition
      :title="page.title"
      :breadcrumbs="breadcrumbs"
    ></section-definition>
    <v-card class="ml-3 mr-3 mb-5">
      <v-card-title>
        <download-excel :data="machines" :fields="json_fields"
          name="equipos.xls"
          worksheet="Equipos">
          <v-btn round color="primary" dark bold outline >Descargar Excel</v-btn>
        </download-excel>
        <!-- <download-excel :data="machines" :fields="json_fields"
          name="equipos.csv"
          type="csv"
          worksheet="Equipos">
          <v-btn round color="primary" dark bold outline>Descargar CSV</v-btn>
        </download-excel> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar..."
          single-line
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="machines"
        :search="search"
        :loading="isLoading"
        rows-per-page-text="Filas por página"
        :rows-per-page-items="[15, 30, 50, { text: 'todas', value: -1 }]"
        class="elevation-1"
      >
        <v-progress-linear
          slot="progress"
          color="blue"
          indeterminate
        ></v-progress-linear>

        <template slot="items" slot-scope="props">
          <td>
            <img height="80" class="justify-center" :src="props.item.imgurl" />
          </td>
          <td class="text-xs-center">{{ props.item.owneralias }}</td>
          <td class="text-xs-center">{{ props.item.machinename }}</td>
          <td class="text-xs-center">{{ props.item.machineserialnumber }}</td>
          <td class="text-xs-center">{{ props.item.machinetypelabel }}</td>
          <td class="text-xs-center">{{ props.item.machinebrandname }}</td>
          <td class="text-xs-center">{{ props.item.machinemodel }}</td>
          <td class="text-xs-center">{{ props.item.machineprice }}</td>
          <td class="text-xs-center">{{ props.item.machinedescription }}</td>
          <td class="text-xs-center">{{ props.item.machinepower }}</td>
          <td class="text-xs-center">{{ props.item.machinelocation }}</td>
          <td class="text-xs-center">
            <v-chip :color="props.item.machinestatuscolor" dark>{{ props.item.machinestatuslabel }}</v-chip>
          </td>
          <td>
            <v-icon
              small
              class="mr-2"
              @click="gotoDetail(props.item.machineuuid)"
            >
              edit
            </v-icon>
          </td>
        </template>
        <template slot="pageText" slot-scope="props">
          Filas {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          La búsqueda de "{{ search }}" no ha encontrado resultados.
        </v-alert>
      </v-data-table>
    </v-card>
    <v-snackbar
      v-model="snackresult"
      :color="snackcolor"
      :timeout="6000"
      top="true"
    >
      {{ snacktext }}
      <v-btn round color="primary" dark bold outline @click="snackresult = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  name: "MachinesList",
  data() {
    return {
      machines: null,
      search: "",
      headers: [
        { text: "", value: "", sortable: false },
        { text: "Alias/Propietario", value: "owneralias" },
        { text: "Equipo", value: "machinename" },
        { text: "Nª chasis", value: "machineserialnumber" },
        { text: "Tipo", value: "machinetypelabel" },
        { text: "Marca", value: "machinebrandname" },
        { text: "Modelo", value: "machinemodel" },
        { text: "Precio (€)", value: "machineprice" },
        { text: "Descripcion ", value: "machinedescription" },
        { text: "Potencia", value: "machinepower" },
        { text: "Lugar", value: "machinelocation" },
        { text: "Estado", value: "machinestatuslabel" },
        { text: "Acciones ", value: "" }
      ],
      currentMachine: {},
      snackbar: false,
      snackresult: false,
      snacktext: "",
      snackcolor: "success",
      isLoading: false,
      page: {
        title: "Equipos",
        headline: "Lista de equipos",
        description: "Equipos activos"
      },
      breadcrumbs: [
        {
          text: "Equipos Activos",
          disabled: false
        }
      ],
      json_fields: {
        "Alias/Propietario": "owneralias",
        Equipo: "machinename",
        "Número de chasis": "machineserialnumber",
        Tipo: "machinetypelabel",
        Marca: "machinebrandname",
        Modelo: "machinemodel",
        "Precio (€)": {
          field: "machineprice",
          callback: value => {
            var valstr = value.toString();
            if (valstr.indexOf(".") > 0) {
              var newvalue = valstr.replace(".", ",");
              return newvalue;
            }
            return value;
          }
        },
        Descripcion: "machinedescription",
        "Potencia (CV)": "machinepower",
        "ID Propietario": "machineowner",
        "ID Equipo": "machineid",
        "Lugar ": "machinelocation",
      }
    };
  },
  computed: {
    machines() {
      for (var a = 0; a < this.$store.state.machines.machines.length; a++) {
        this.$store.state.machines.machines[a].imgurl =
          "https://ploou-produccion.appspot.com/getimage/" +
          this.$store.state.machines.machines[a].imageuuid;
        if (this.$store.state.machines.machines[a].imageuuid === "") {
          this.$store.state.machines.machines[a].imgurl =
            "https://ploou-produccion.appspot.com/getimage/86964f76-fb15-4cc2-a57e-d8438eda5a22";
        }
        this.$store.state.machines.machines[a].machinerate = 5;
      }
      return this.$store.state.machines.machines;
    }
  },
  mounted: function() {
    this.getmachines(1);
  },
  methods: {
    gotoDetail: function(uuid) {
      this.$router.push({
        path: "/pages/machinedetail/:id",
        query: { id: uuid }
      });

      // this.$router.push({ path: '/machinedetail'})
    },
    getmachines: function(typemachine) {
      const self = this;
      //  let url = process.env.VUE_APP_BASE_URI + '/filtermachinesbyspecs'
      let url = process.env.VUE_APP_BASE_URI + "/getmachinesforcompany";
      var filtersx = {
        filters: {
          machinetype: typemachine
        }
      };
      this.isLoading = true;
      self.$http.get(url).then(
        function(success) {
          self.isLoading = false;
          for (var a = 0; a < success.data.machines.length; a++) {
            success.data.machines[a].imgurl =
              process.env.VUE_APP_BASE_URI +
              "/getimage/" +
              success.data.machines[a].imageuuid;
            if (success.data.machines[a].imageuuid === "") {
              success.data.machines[a].imgurl =
                process.env.VUE_APP_BASE_URI +
                "/getimage/86964f76-fb15-4cc2-a57e-d8438eda5a22";
            }
            if (success.data.machines[a].machinelocation != null) {
              success.data.machines[a].machinelocation = success.data.machines[
                a
              ].machinelocation.replace(",", ", ");
            }
            success.data.machines[a].machinerate = 5;
            if (success.data.machines[a].machinestatus == 1) {
              success.data.machines[a].machinestatuslabel = "Activo";
              success.data.machines[a].machinestatuscolor = "green";
            } else if (success.data.machines[a].machinestatus == 2) {
              success.data.machines[a].machinestatuslabel = "Inactivo";
              success.data.machines[a].machinestatuscolor = "orange";
            } else {
              success.data.machines[a].machinestatuslabel = "Eliminado";
              success.data.machines[a].machinestatuscolor = "red";
            }
            if (success.data.machines[a].machinetype == 1) {
              success.data.machines[a].machinetypelabel = "Tractor";
            } else if (success.data.machines[a].machinetype == 2) {
              success.data.machines[a].machinetypelabel = "Remolcada";
            } else {
              success.data.machines[a].machinetypelabel = "E. Verdes";
            }
            var strdesc = success.data.machines[a].machinedescription;
            if (strdesc !== undefined && strdesc !== null) {
              var first = strdesc.split(" ");
              if (
                success.data.machines[a].machinedescription.length > 20 &&
                first.length < 2
              )
                success.data.machines[a].machinedescription = "xx";
            }

            var result = self.$store.getters.premiumusers.filter(obj => {
              return obj.iduser === success.data.machines[a].machineowner;
            });
            self.machines = success.data.machines;
          }
        },
        function(error) {
          self.isLoading = false;
          self.snacktext = "Error al obtener lista de equipos";
          self.snackcolor = "error";
          self.snackresult = true;
        }
      );
    }
  }
};
</script>
<style scoped>
</style>
